const Loader = () => {
  return (
    <div className="flex absolute z-99999 inset-0 items-center justify-center bg-slate-200/20 backdrop-blur-sm">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
